<template>
    <div>
        <div class="content">
            <Logo :items="items"></Logo>
            <!-- route outlet -->
            <router-view></router-view>
        </div>
        <footer class="footer">
            <div class="container">
                <div class="row align-content-center">
                    <div class="col-12 col-sm-8 float-right">
                        تمامی حقوق لایوی محفوظ است.
                    </div>
                    <div class="col-12 col-sm-4 float-left text-left">
                        <a href="/map"> نقشه </a>
                        <a href="/contactus" class="mr-3"> تماس با ما </a>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    import Logo from "../components/Logo";
    import { NAV_ITEMS } from "@/utils/navItems";

    export default {
        name: "Master",
        components: {
            Logo
        },
        data() {
            return {
                items: NAV_ITEMS
            }
        }
    }
</script>

<style>

</style>

<style scoped>
    .footer {
        width: 100%;
        background-color: whitesmoke;
        font-size: 14px;
        line-height: 80px;
    }
</style>
